import React from 'react'
import AppBackBtn from '../components/ui/AppBackBtn'
import AppWrapper from '../components/ui/AppWrapper/AppWrapper'
import AppWrapperTitle from '../components/ui/AppWrapperTitle'
import HistoryList from '../components/history/HistoryList'

const HistoryView: React.FC = () => {
  return (
    <>
      <AppBackBtn to="/home" />
      <AppWrapper className="bg-white h-[80%]">
        <AppWrapperTitle>История</AppWrapperTitle>
        <HistoryList />
      </AppWrapper>
    </>
  )
}

export default HistoryView
